import React, { useState } from 'react';
import { Popover } from 'antd';
import { OptionsIcon } from '@gtintel/platform-atoms';
import * as S from './styles';
const OptionsPopover = ({
  title,
  children
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const handleOnVisibleChange = () => setIsVisible(!isVisible);
  return <Popover content={<S.OptionsContainer>{children}</S.OptionsContainer>} title={title} trigger="click" visible={isVisible} onVisibleChange={handleOnVisibleChange}>
      <S.Options>
        <OptionsIcon />
      </S.Options>
    </Popover>;
};
export default OptionsPopover;